import { useNavigate } from 'react-router-dom';

// Hook pour la navigation avec tracking de section
const useSectionNavigation = () => {
  const navigate = useNavigate();

  const navigateToDetail = (url, currentSectionId) => {
    // Sauvegarder la section actuelle dans l'état de l'historique
    if (window.history.replaceState && currentSectionId) {
      window.history.replaceState(
        { ...window.history.state, fromSection: currentSectionId },
        ''
      );
    }
    
    // Naviguer vers la page de détail
    navigate(url);
  };

  return { navigateToDetail };
};

export default useSectionNavigation;